export const downloadNotes = (rs) => {
    console.log('TODO: Download notes', rs);
};
//# sourceMappingURL=download.js.map